// Import and expose global libraries
import './IncrementViewCount'; // Exposes window.UI
import './PostMessageChannel'; // Exposes window.MW
// Detail page specific modules
import './file_infos/DiscussionsService';
import './file_infos/follow';
import './file_infos/track_downloads';
import './file_infos/copy_to_clipboard';
import './file_infos/dynamic_spotlight';
import { OpenWithConfigurationForm } from './file_infos/OpenWithConfigurationForm';
import './file_infos/version_tab_navigation';
import './bootstrap_components';
import './detail_page';
import './related_content';
import './citations';
import { MarkdownRenderer } from 'markdown-renderer/MarkdownRenderer';

document.addEventListener('DOMContentLoaded', function () {
    const readmeBody = document.getElementById('readmeBody');
    if (readmeBody && MarkdownRenderer && readmeBody.dataset.readmeMarkdown) {
        new MarkdownRenderer().render(readmeBody);
    }

    const openInMatlabOnlineButton = document.getElementById('openInMatlabOnlineButton');
    if (openInMatlabOnlineButton) {
        openInMatlabOnlineButton.addEventListener('click', function (e) {
            if (this.classList.contains('disabled') || this.getAttribute('aria-disabled') === 'true') {
                e.preventDefault();
                return false;
            }
        });
    }

    const openWithSettingsSaveButton = document.getElementById('openWithSettingsSaveButton');
    if (openWithSettingsSaveButton) {
        const openWithConfigurationForm = new OpenWithConfigurationForm();

        openWithSettingsSaveButton.addEventListener('click', function () {
            openWithConfigurationForm.save();
        });

        const fileParameter = document.getElementById('fileParameter');
        if (fileParameter) {
            fileParameter.addEventListener('focus', function () {
                openWithConfigurationForm.hideFeedback();
            });
            fileParameter.addEventListener('focusout', function () {
                openWithConfigurationForm.validateAndUpdateLink();
            });
        }

        const projectParameter = document.getElementById('projectParameter');
        if (projectParameter) {
            projectParameter.addEventListener('focus', function () {
                openWithConfigurationForm.hideFeedback();
            });
            projectParameter.addEventListener('focusout', function () {
                openWithConfigurationForm.validateAndUpdateLink();
            });
        }

        const openWithSettingsModal = document.getElementById('openWithSettingsModal');
        if (openWithSettingsModal) {
            openWithSettingsModal.addEventListener('hidden.bs.modal', function () {
                openWithConfigurationForm.reset();
            });
        }
    }
});
